import styled from "styled-components";
import { CSSProperties } from "react";

// Estilo para os formulários
export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  border: "3px solid black",
  margin: "15px",
  padding: "1rem",
  background: "#f0f4f7",
  borderRadius: "10px",
};

// Layout padrão do formulário
export const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

// Botão padrão
export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // Para garantir que o layout seja responsivo
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhamento vertical em telas menores */
  }

  & > :first-child {
    flex: 0 0 10%; /* 10% para o topo */
  }

  & > :last-child {
    flex: 1; /* 90% para o conteúdo restante */
  }
`;

// Container do título
export const ContainerTitulo = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
`;

// Container para os botões de ação (adicionar categoria)
export const ContainerBotoes = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

// Container da tabela
export const ContainerTabela = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 1rem;
`;

// Estilos de botões dentro da tabela
export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &:hover {
    cursor: pointer;
  }
`;

// Títulos
export const Title = styled.h1`
  font-size: 25px;
  font-weight: bold;
  color: #003644;
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #003644;
`;

// Container do modal
export const ContainerModalBtn = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;
